import Alt from "alt";
import chromeDebug from "alt-utils/lib/chromeDebug";

var alt = new Alt();
chromeDebug(alt);

export default alt;



// WEBPACK FOOTER //
// ./src/app/alt.js